import { StudentProfileInfo } from '@interfaces/Student'
import { IGetSchedulesIdVars } from '@layouts/Settings/LessonHistory/interface'
import { isString, omit } from 'lodash'
import moment from 'moment'

export const getProgramIds = (studentProfile: StudentProfileInfo) => {
  const programs = studentProfile?.ProgramStudentWrappers ?? []
  return programs.map(({ ProgramStudentInfo }) => ProgramStudentInfo.ProgramId)
}

export const getEarliestFromDate = (studentProfile: StudentProfileInfo) => {
  const programs = studentProfile?.ProgramStudentWrappers ?? []
  const dates = programs
    .map(({ ProgramStudentInfo }) => moment(ProgramStudentInfo.ProgramEnrollDate))
    .filter((momentDate) => momentDate.isValid())

  return moment.min(dates).clone().utc().subtract(1, 'day').startOf('day').format()
}

export const getLessonHistoryVariables = (variables: IGetSchedulesIdVars) => {
  const varProgramIds = variables.ProgramIds || ''
  const ProgramIds: string[] = isString(varProgramIds) ? varProgramIds.split(',') : varProgramIds || []

  if (ProgramIds.length > 1) {
    return omit(
      {
        ...variables,
        ProgramIds: ProgramIds.join(','),
      },
      ['FromDate', 'EndDate']
    )
  }

  return {
    ...variables,
    ProgramIds: ProgramIds.join(','),
  }
}
